import { Container } from "@dxp-feed/ui/Container";
export const SiteContainer = ({
  children,
  className = "",
}: {
  children?: React.ReactNode;
  className?: string;
}) => {
  return (
    <Container className={`px-6 2md:px-12 max-w-[1536px] ${className}`}>
      {children}
    </Container>
  );
};
